import {
    SET_ZONE_OPTIONS,
    SET_ALL_ZONES,
    SET_ZONE_PARKING_ASSISTANT_SETTINGS,
    UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
    GET_PARKING_PHOTO_SETTINGS_SUCCESS,
    type ZoneState,
} from 'src/redux/zone/zone.types'
import { type ZoneAction } from 'src/redux/zone/zone.actions'

export const INITIAL_STATE: ZoneState = {
    zoneOptions: [],
    allZones: [],
    zoneParkingAssistantSettings: null,
    parkingPhotoSettings: [],
}

export function zoneReducer(state: ZoneState = INITIAL_STATE, action: ZoneAction): ZoneState {
    switch (action.type) {
        case SET_ZONE_OPTIONS:
            return { ...state, zoneOptions: action.payload }

        case SET_ALL_ZONES:
            return { ...state, allZones: action.payload }

        case SET_ZONE_PARKING_ASSISTANT_SETTINGS:
            return {
                ...state,
                zoneParkingAssistantSettings: action.payload,
            }

        case UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS:
            return {
                ...state,
                zoneParkingAssistantSettings: action.payload,
            }

        case GET_PARKING_PHOTO_SETTINGS_SUCCESS: {
            const { parkingPhotoSettings } = action.payload
            return { ...state, parkingPhotoSettings }
        }

        default:
            return state
    }
}
